export default "/images/vendor/flag-icon-css/flags/4x3/bh.svg?ec61516daebfebe2cd499a46c9f6570a";